import { render, staticRenderFns } from "./WorkbookHeader.vue?vue&type=template&id=5b4705ef&"
import script from "./WorkbookHeader.vue?vue&type=script&lang=js&"
export * from "./WorkbookHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports